export default "__VITE_ASSET__DtGSf$E0__"